(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const form = document.querySelector('[data-catalog-filters]');
  const grid = document.querySelector('[data-catalog-grid]');
  const chips = document.querySelector('[data-filter-chips]');
  const countEl = document.querySelector('[data-catalog-count]');
  const emptyEl = document.querySelector('[data-catalog-empty]');
  const clearBtn = document.querySelector('[data-filter-clear]');
  let cards = grid ? [...grid.querySelectorAll('.catalog-card')] : [];
  const initialCards = new Set(cards);
  const pagination = document.querySelector('.catalog-main .pagination');
  let catalogReady = Number(grid?.dataset.pages || 1) <= 1;
  let catalogLoad;
  const normalizeCards = () => cards.forEach(card => {
    const title = (card.querySelector('.catalog-card__title')?.textContent || '').toLocaleLowerCase('tr');
    const type = (card.dataset.type || '').toLocaleLowerCase('tr');
    const material = (card.dataset.material || '').toLocaleLowerCase('tr');
    const searchable = [title, type, material].join(' ');
    if (!card.dataset.pieces) card.dataset.pieces = title.match(/(\d+)\s*parça/)?.[1] || '';
    if (!card.dataset.material && searchable.includes('hakiki deri')) card.dataset.material = 'Hakiki deri';
    else if (!card.dataset.material && (searchable.includes('gerçek deri') || searchable.includes('gercek deri'))) card.dataset.material = 'Gerçek deri';
    else if (!card.dataset.material && searchable.includes('suni deri')) card.dataset.material = 'Suni deri';
    else if (!card.dataset.material && searchable.includes('kristal')) card.dataset.material = 'Kristal';
    else if (!card.dataset.material && (searchable.includes('ahşap') || searchable.includes('ahsap'))) card.dataset.material = 'Ahşap';
    else if (!card.dataset.material && searchable.includes('metal')) card.dataset.material = 'Metal';
    else if (!card.dataset.material && searchable.includes('deri')) card.dataset.material = 'Deri';
    if (title.includes('kalem')) card.dataset.pen = '1';
    if (title.includes('saat')) card.dataset.clock = '1';
    if (title.includes('isimli')) card.dataset.personal = '1';
    if (title.includes('bayraklı') || title.includes('bayrakli')) card.dataset.flag = '1';
    if (title.includes('evrak raf') || title.includes('kağıt raf') || title.includes('kagit raf')) card.dataset.shelf = '1';
  });
  const buildPieces = () => {
    const group = form?.querySelector('[data-filter-group="pieces"]');
    if (!group) return;
    const selected = group.querySelector('input:checked')?.value || '';
    group.querySelectorAll('label').forEach(label => label.remove());
    ['', ...[...new Set(cards.map(card => String(card.dataset.pieces || '').replace(/\D/g, '')).filter(Boolean))].sort((a,b) => Number(a)-Number(b))].forEach(value => {
      const label = document.createElement('label'); label.className = 'filter-option';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'pieces'; input.value = value; input.checked = value === selected;
      label.append(input, value ? ' ' + value + ' parça' : ' Tümü'); group.append(label);
    });
  };
  const buildMaterials = () => {
    const group = form?.querySelector('[data-filter-group="material"]');
    if (!group) return;
    const selected = group.querySelector('input:checked')?.value || '';
    group.querySelectorAll('label').forEach(label => label.remove());
    const values = [...new Set(cards.map(card => card.dataset.material || '').filter(Boolean))].sort((a,b) => a.localeCompare(b, 'tr'));
    ['', ...values].forEach(value => {
      const label = document.createElement('label'); label.className = 'filter-option';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'material'; input.value = value; input.checked = value === selected;
      label.append(input, value ? ' ' + value : ' Tümü'); group.append(label);
    });
  };
  const buildColors = () => {
    const group = form?.querySelector('[data-filter-group="color"]');
    if (!group) return;
    const selected = group.querySelector('input:checked')?.value || '';
    group.querySelectorAll('label').forEach(label => label.remove());
    const values = [...new Set(cards.flatMap(card => (card.dataset.colors || '').split('|').filter(Boolean)))].sort((a,b) => a.localeCompare(b, 'tr'));
    ['', ...values].forEach(value => {
      const label = document.createElement('label'); label.className = 'filter-option';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'color'; input.value = value; input.checked = value === selected;
      label.append(input);
      if (value) {
        const swatch = document.createElement('span'); swatch.className = 'filter-swatch'; swatch.dataset.color = value; swatch.setAttribute('aria-hidden', 'true');
        label.append(swatch, document.createTextNode(value));
      } else label.append(document.createTextNode('Tümü'));
      group.append(label);
    });
  };
  const loadCatalog = async () => {
    if (catalogReady) return;
    if (catalogLoad) return catalogLoad;
    catalogLoad = (async () => {
      if (countEl) countEl.textContent = 'Tüm modeller hazırlanıyor…';
      form.inert = true;
      const current = Number(grid.dataset.page || 1);
      const pageCards = new Map([[current, cards]]);
      for (let page = 1; page <= Number(grid.dataset.pages || 1); page++) {
        if (page === current) continue;
        const url = new URL(location.href); url.searchParams.set('page', page);
        const response = await fetch(url, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('catalog');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = [...doc.querySelectorAll('[data-catalog-grid] .catalog-card')];
        if (!items.length) throw new Error('catalog');
        pageCards.set(page, items);
      }
      cards = [...pageCards.entries()].sort((a,b) => a[0]-b[0]).flatMap(entry => entry[1]);
      cards.forEach(card => { if (!initialCards.has(card)) card.hidden = true; grid.append(card); });
      catalogReady = true; normalizeCards(); buildPieces(); buildMaterials(); buildColors();
    })().finally(() => { form.inert = false; catalogLoad = null; });
    return catalogLoad;
  };
  normalizeCards(); buildPieces(); buildMaterials(); buildColors();

  const readState = () => {
    if (!form) return {};
    const data = new FormData(form);
    return {
      pieces: data.get('pieces') || '',
      material: data.get('material') || '',
      color: data.get('color') || '',
      personal: data.get('personal') === '1',
      flag: data.get('flag') === '1',
      shelf: data.get('shelf') === '1',
      pen: data.get('pen') === '1',
      clock: data.get('clock') === '1',
      price: data.get('price') || ''
    };
  };

  const priceMatch = (card, range) => {
    if (!range) return true;
    const price = Number(card.getAttribute('data-price') || 0);
    const bits = range.split('-');
    const min = Number(bits[0] || 0);
    const max = bits[1] === '' || bits[1] == null ? Infinity : Number(bits[1]);
    return price >= min && price < max;
  };

  const pieceValue = (card) => String(card.getAttribute('data-pieces') || '').replace(/\D/g, '');

  const cardMatches = (card, state) => {
    if (state.pieces && pieceValue(card) !== String(state.pieces)) return false;
    if (state.material && card.getAttribute('data-material') !== state.material) return false;
    if (state.color && !(card.dataset.colors || '').split('|').includes(state.color)) return false;
    if (state.personal && card.getAttribute('data-personal') !== '1') return false;
    if (state.flag && card.getAttribute('data-flag') !== '1') return false;
    if (state.shelf && card.getAttribute('data-shelf') !== '1') return false;
    if (state.pen && card.getAttribute('data-pen') !== '1') return false;
    if (state.clock && card.getAttribute('data-clock') !== '1') return false;
    if (!priceMatch(card, state.price)) return false;
    return true;
  };

  const labels = {
    pieces: (v) => v + ' parça',
    material: (v) => v,
    color: (v) => v,
    personal: () => 'Kişiselleştirilebilir',
    flag: () => 'Masa bayraklı',
    shelf: () => 'Evrak rafı',
    pen: () => 'Kalemli',
    clock: () => 'Saatli',
    price: (v) => v === '0-200000' ? '2000 TL altı' : v === '200000-400000' ? '2000–4000 TL' : '4000 TL ve üzeri'
  };

  const applyFilters = () => {
    if (!form || !grid) return;
    const state = readState();
    const hasFilters = Object.values(state).some(Boolean);
    let visible = 0;
    cards.forEach((card) => {
      const show = (hasFilters || initialCards.has(card)) && cardMatches(card, state);
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (countEl) countEl.textContent = hasFilters ? visible + ' ürün bulundu' : grid.dataset.total + ' ürün';
    if (pagination) pagination.hidden = hasFilters;
    try { sessionStorage.setItem('catalog-filters:' + location.pathname, JSON.stringify(state)); } catch (_) {}
    if (emptyEl) emptyEl.hidden = visible > 0 || cards.length === 0;
    const active = [];
    if (state.pieces) active.push({ key: 'pieces', label: labels.pieces(state.pieces) });
    if (state.material) active.push({ key: 'material', label: labels.material(state.material) });
    if (state.color) active.push({ key: 'color', label: labels.color(state.color) });
    if (state.personal) active.push({ key: 'personal', label: labels.personal() });
    if (state.flag) active.push({ key: 'flag', label: labels.flag() });
    if (state.shelf) active.push({ key: 'shelf', label: labels.shelf() });
    if (state.pen) active.push({ key: 'pen', label: labels.pen() });
    if (state.clock) active.push({ key: 'clock', label: labels.clock() });
    if (state.price) active.push({ key: 'price', label: labels.price(state.price) });
    if (chips) {
      chips.replaceChildren();
      active.forEach((item) => {
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'filter-chip';
        chip.textContent = item.label;
        chip.setAttribute('aria-label', item.label + ' filtresini kaldır');
        chip.addEventListener('click', () => {
          const input = form.querySelector('[name="' + item.key + '"][value=""]') || form.querySelector('[name="' + item.key + '"]');
          if (input && input.type === 'checkbox') input.checked = false;
          else if (input) input.checked = true;
          applyFilters();
        });
        chips.append(chip);
      });
      chips.hidden = active.length === 0;
    }
    if (clearBtn) clearBtn.hidden = active.length === 0;
    form.querySelectorAll('.filter-option input').forEach((input) => {
      if (input.value === '' || (input.type === 'checkbox' && !input.checked && !input.value)) {
        input.disabled = false;
        return;
      }
      const next = Object.assign({}, state);
      if (input.type === 'checkbox') next[input.name] = true;
      else next[input.name] = input.value;
      const any = cards.some((card) => cardMatches(card, next));
      input.disabled = !any && !input.checked;
    });
    form.querySelectorAll('[data-filter-group]').forEach((group) => {
      const key = group.getAttribute('data-filter-group');
      const present = cards.some((card) => {
        if (key === 'pieces') return Boolean(pieceValue(card));
        if (key === 'material') return Boolean(card.getAttribute('data-material'));
        if (key === 'color') return Boolean((card.dataset.colors || '').split('|').filter(Boolean).length);
        if (key === 'feature') {
          return card.getAttribute('data-personal') === '1' || card.getAttribute('data-flag') === '1' || card.getAttribute('data-shelf') === '1' || card.getAttribute('data-pen') === '1' || card.getAttribute('data-clock') === '1';
        }
        return true;
      });
      group.hidden = !present;
      const dropdown = group.closest('.catalog-filter');
      if (dropdown) {
        dropdown.hidden = !present;
        const selection = dropdown.querySelector('[data-filter-selection]');
        const selected = [...group.querySelectorAll('input:checked')].filter(input => input.value);
        if (selection) selection.textContent = selected.length ? '(' + selected.length + ')' : '';
      }
    });
  };

  const dropdowns = [...(form?.querySelectorAll('.catalog-filter') || [])];
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('toggle', () => {
      if (dropdown.open) dropdowns.forEach(other => { if (other !== dropdown) other.open = false; });
    });
  });
  document.addEventListener('click', event => {
    dropdowns.forEach(dropdown => { if (!dropdown.contains(event.target)) dropdown.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    dropdowns.forEach(dropdown => {
      if (!dropdown.open) return;
      dropdown.open = false;
      if (dropdown.contains(document.activeElement)) dropdown.querySelector('summary')?.focus();
    });
  });
  form?.addEventListener('change', event => {
    applyFilters();
    if (event.target.type === 'radio') {
      const dropdown = event.target.closest('.catalog-filter');
      if (dropdown) { dropdown.open = false; dropdown.querySelector('summary')?.focus(); }
    }
  });
  form?.addEventListener('reset', () => requestAnimationFrame(applyFilters));
  clearBtn?.addEventListener('click', (event) => {
    event.preventDefault();
    form?.reset();
    applyFilters();
  });
  const initializeCatalog = async () => {
    try {
      await loadCatalog();
      let saved; try { saved = JSON.parse(sessionStorage.getItem('catalog-filters:' + location.pathname) || 'null'); } catch (_) {}
      if (saved) form?.querySelectorAll('input').forEach(input => { input.checked = input.type === 'checkbox' ? Boolean(saved[input.name]) : input.value === String(saved[input.name] || ''); });
      applyFilters();
    } catch (_) {
      if (countEl) { countEl.textContent = 'Tüm modeller yüklenemedi. '; const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'text-link'; retry.textContent = 'Yeniden dene'; retry.addEventListener('click', initializeCatalog); countEl.append(retry); }
      if (form) form.inert = true;
    }
  };
  document.querySelector('#SortBy')?.addEventListener('change', event => {
    const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); location.href = url.href;
  });
  if (form && grid) initializeCatalog();

  } catch(e) { console.error(e); }
})();
})();
